export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13142.9d8af8c2.jpg";